import { BaseProyectaService } from "./base-proyecta.service";
import { ILang } from "../../models";
import { Enums, Dictionary, Constants, String, Utilities, moment } from "../../utils/utilities";
import { IFollowupBasicDataMasters, ISPItem, IFollowupIndicators, IFollowupFinancial, IFollowupBeneficiaries } from "../../models";
import {
  IDtoGetStepSDC,
  IFEStep1,
  IFEStep1Anio,
  IFEStep1Beneficiario,
  IFEStep1Dto,
  IFEStep2,
  IFEStep2Dto,
  IFEStep2DtoModel,
  IFEStep3,
  IFEStep3Dto,
  IFEStep4,
  IFEStep4Actividad,
  IFEStep4ActivitiesDtoModel,
  IFEStep4Dto,
  IFEStep4IndicadoresDtoModel,
  IFEStep4IndicadorMri,
  IFEStep4IndicadorObjetivo,
  IFEStep4MriIndicadorDtoModel,
  IFEStep4ResultadoEsperado,
  IFEStep4ResultadoEsperadoDetalle,
  IFEStep4ResultsDetailsDtoModel,
  IFEStep4ResultsDtoModel,
  ISpfrStep1,
  ISpfrStep1Anio,
  ISpfrStepSDC,
  } from "@models/*";
import { constants } from "buffer";

export interface IFollowupService{
	getAllFormMasters(langLabel: string): Promise<IFollowupBasicDataMasters>;
	getIndicatorsData(followupId: string): Promise<IFollowupIndicators>;
	getBeneficiariesData(followupId: string): Promise<IFollowupBeneficiaries>;
	getAllBeneficiariesData(): Promise<IFollowupBeneficiaries>;
	getAllFollowupData(): Promise<any>;
	getFinancialData(followupId: string): Promise<IFollowupFinancial>;
	getResultsFramework(followupId: string, subvCode?: string): Promise<any>;
	getInstitutionalIndicators(followupId: string, subvCode?: string): Promise<any>;
	getNarrativeReport(followupId: string): Promise<any>;
	getInfoByProject(PPresCodProy: string): Promise<any>;
	getInfoByCountry(idCountry: string, isCountry: boolean, year: string): Promise<any>;
	getLangs(): Promise<ILang[]>;
	getLabels(lang: string): Promise<Dictionary<string,string>>;
	getOnlyFollowupData(): Promise<any>;
	getSubProjectDimensions(): Promise<any>;
	getSubProjectDimensionsfilter(subproyecid :any,typed:any):Promise<any>;
	getSubProjectPeriods(): Promise<any>;
	getFollowupData(): Promise<any>;
	getDefinitionColumnsAdmin(langId: number): Promise<Dictionary<string, any>>;
	getDefinitionColumnsIndex(langId: number): Promise<Dictionary<string, any>>;
	getDefinitionColumnsIndicators(langId: number): Promise<Dictionary<string, any>>;
	getDefinitionColumnsFinancial(langId: number): Promise<Dictionary<string, any>>;
	getDefinitionColumnsBeneficiaries(langId: number): Promise<Dictionary<string, any>>;
	addIndexFollowup(IndexFollowup: any, listname: string, currentUserEmail?: string): Promise<any>;
	updateIndexFollowup(IndexFollowup: any, listname: string, currentUserEmail?: string): Promise<any>;
	addItemIndexFollowup(listName: string, item: any, currentUserEmail?: string): Promise<any>;
	updateItemIndexFollowup(listName: string, item: any, currentUserEmail?: string): Promise<any>;
	fixActFinancialData(listName: string, item: any, currentUserEmail?: string): Promise<any>;
	fixActIndicatorsData(listName: string, item: any, currentUserEmail?: string): Promise<any>;
	fixActBeneficiariesData(listName: string, item: any, currentUserEmail?: string): Promise<any>;
	getSPFE(followupId: string, subvCode?: string): Promise<any>;
	getMigrationData(): Promise<any>;
}

export class FollowupService extends BaseProyectaService implements IFollowupService {
    public async getLangs(): Promise<ILang[]> {
        const langs = await this.spListService.getItems<ISPItem>({listName:Enums.ListTypes.Langs, filter:Constants.FiltersFormats.LANG_IS_ACTIVE})
        return langs.map(item => {
            return {
                id: item.Id,
                label: item.Title
            }
        });
    }

	public async getOnlyFollowupData(): Promise<any> {
        const followupData = await  this.spListService.getItems<any>({
                listName: Enums.ListTypes.IndexFollowup
            })
        return followupData;
    }

	public async getSubProjectDimensions(): Promise<any> {
        const subProjectDimensions = await  this.spListService.getItems<any>({
			listName: Enums.ListTypes.SeguimientoEstadoSubproyectoDimensiones,
			columnsToSelect: Constants.Selects.FOLLOWUP_DIMENSION_USER_RESULT,
			expands: Constants.Expands.FOLLOWUP_DIMENSION_USER,
		})
        return subProjectDimensions;
    }

	
	public async getSubProjectDimensionsfilter(subp: any,tipo :any): Promise<any> {
        const subProjectDimensions = await  this.spListService.getItems<any>({
			listName: Enums.ListTypes.SeguimientoEstadoSubproyectoDimensiones,
			columnsToSelect: Constants.Selects.FOLLOWUP_SUBPROJECTS_DIMENTIONS,
			expands: Constants.Expands.FOLLOWUP_SUBPROJECTS_DIMENSION,
			filter:String.Format(Constants.FiltersFormats.FILTER_BY_SUBPROYECTOANIO_DIMENTION, subp,tipo),
		

		})
        return subProjectDimensions;
    }

	public async getSubProjectPeriods(): Promise<any> {
        const subProjectPeriods = await  this.spListService.getItems<any>({
			listName: Enums.ListTypes.SeguimientoEstadoSubproyectoPeriodos
		})
        return subProjectPeriods;
    }

    public async getFollowupData(): Promise<any> {
        const [followupData, subProjectDimensions, subProjectMonths, subProjectPeriods] = await Promise.all([
            this.spListService.getItems<any>({
                listName: Enums.ListTypes.IndexFollowup
            }), 
            this.spListService.getItems<any>({
                listName: Enums.ListTypes.SeguimientoEstadoSubproyectoDimensiones,
				columnsToSelect: Constants.Selects.FOLLOWUP_DIMENSION_USER_RESULT,
				expands: Constants.Expands.FOLLOWUP_DIMENSION_USER,
            }), 
            this.spListService.getItems<any>({
                listName: Enums.ListTypes.SeguimientoEstadoSubproyectoMeses
            }), 
            this.spListService.getItems<any>({
                listName: Enums.ListTypes.SeguimientoEstadoSubproyectoPeriodos
            })
        ]);
        return {followupData, subProjectDimensions, subProjectMonths, subProjectPeriods};
    }

    public async getAllFormMasters(
        langLabel: string
    ): Promise<IFollowupBasicDataMasters> {
        const result = await Promise.all([
            this.getRegions(langLabel),
            this.getCountries(langLabel),
            this.getGrantCodes(langLabel),
            this.getInterventionLines(langLabel),
            this.getFFCCFinancingEntities(langLabel),
            this.getFFRRFinancingEntities(langLabel),
            this.getFollowupState(langLabel),
            this.getFollowupDimensions(langLabel),
            this.getMeasureUnits(langLabel),
            this.getSuccessCriteria(langLabel),
            this.getFrecuency(langLabel),
			this.getStrategicLines(langLabel),
			this.getProductsIndicator(langLabel),
			this.getIntermediateResultIndicator(langLabel),
			this.getCounterpartType(langLabel),
			this.getSLEP(langLabel),
			this.getAgeRange(langLabel),
			this.getRuralities(langLabel),
			this.getInPeriods(langLabel),
        ]) as any;
        return {
            regions: result[0],
            countries: result[1],
            grantCodes: this.processGrantCodes(result[2]),
            interventionLines: result[3],
            ffccFinancer: result[4],
            ffrrFinancer: result[5],
            allFinancers: [...result[4], ...result[5]],
            followupState: result[6],
            followupDimensions: result[7],
            measureUnits: result[8],
            criterioDeExito: result[9],
            frecuenciaDeMedicion: result[10],
			strategicLine: result[11],
			productsIndicator: result[12],
			intermediateIndicatorResults: result[13],
			counterpartType: result[14],
			slep: result[15],
			ageRange: result[16],
			ruralities: result[17],
			inPeriods: result[18],
        };
    }

	public async addItemIndexFollowup(listName: string, item: any, currentUserEmail?: string) {
		if (currentUserEmail){
			let currentUsu = await this.spWebService.ensureUser(currentUserEmail)
			delete item.PProaModifiedByStringId;
			item.PProaModifiedById = currentUsu.Id 
		}

		return await this.spListService.addItem({ listName, item });
	}

	public async updateItemIndexFollowup(listName: string, item: any, currentUserEmail?: string) {
		if (currentUserEmail){
			let currentUsu = await this.spWebService.ensureUser(currentUserEmail)
			delete item.PProaModifiedByStringId;
			item.PProaModifiedById = currentUsu.Id 
		}
		return await this.spListService.updateItem({listName, itemId: item.Id, item})
	}

	public async fixActFinancialData(listName: string, item: any, currentUserEmail?: string) {
		if (currentUserEmail){
			let currentUsu = await this.spWebService.ensureUser(currentUserEmail)
			delete item.PProaModifiedByStringId;
			item.PProaModifiedById = currentUsu.Id 
		}
		return await this.spListService.updateItem({listName, itemId: item.Id, item})
	}

	public async fixActIndicatorsData(listName: string, item: any, currentUserEmail?: string) {
		if (currentUserEmail){
			let currentUsu = await this.spWebService.ensureUser(currentUserEmail)
			delete item.PProaModifiedByStringId;
			item.PProaModifiedById = currentUsu.Id 
		}
		return await this.spListService.updateItem({listName, itemId: item.Id, item})
	}

	public async fixActBeneficiariesData(listName: string, item: any, currentUserEmail?: string) {
		if (currentUserEmail){
			let currentUsu = await this.spWebService.ensureUser(currentUserEmail)
			delete item.PProaModifiedByStringId;
			item.PProaModifiedById = currentUsu.Id 
		}
		return await this.spListService.updateItem({listName, itemId: item.Id, item})
	}

    public async addIndexFollowup(IndexFollowup: any, listname: string, currentUserEmail?: string) {
		if (currentUserEmail){
			let currentUsu = await this.spWebService.ensureUser(currentUserEmail)
			IndexFollowup = IndexFollowup.map((x:any) => {
				delete x.PProaModifiedByStringId;
				return ({ ...x, PProaModifiedById: currentUsu.Id })
			});
		}

        return await this.spListService.addItemsBatch(listname, IndexFollowup)
    }

    public async updateIndexFollowup(IndexFollowup: any, listname: string, currentUserEmail?: string) {
		if (currentUserEmail){
			let currentUsu = await this.spWebService.ensureUser(currentUserEmail)
			IndexFollowup = IndexFollowup.map((x:any) => {
				delete x.PProaModifiedByStringId;
				return ({ ...x, PProaModifiedById: currentUsu.Id })
			});
		}

        return await this.spListService.updateItemsBatch(listname, IndexFollowup)
    }

    public async getDefinitionColumnsAdmin(langId: number): Promise<Dictionary<string, any>> {
        return await this.getDefinitionColumns(
            langId,
            Enums.ListTypes.AdminColumnDefinition
        );
    }

    public async getDefinitionColumnsIndex(langId: number): Promise<Dictionary<string, any>> {
        return await this.getDefinitionColumns(
            langId,
            Enums.ListTypes.FollowupColumnDefinition
        );
    }
	
	public async getDefinitionColumnsIndicators(langId: number): Promise<Dictionary<string, any>> {
        return await this.getDefinitionColumns(
            langId,
            Enums.ListTypes.IndicatorsColumnDefinition
        );
    }
	public async getDefinitionColumnsBeneficiaries(langId: number): Promise<Dictionary<string, any>> {
        return await this.getDefinitionColumns(
            langId,
            Enums.ListTypes.BeneficiariesColumnDefinition
        );
    }

	public async getDefinitionColumnsFinancial(langId: number): Promise<Dictionary<string, any>> {
        return await this.getDefinitionColumns(
            langId,
            Enums.ListTypes.FinancialColumnDefinition
        );
    }

    public async getLabels(lang: string): Promise<Dictionary<string,string>>{
        const labels = await this.spListService.getItems<any>({
            listName:Enums.ListTypes.FollowupLabels,
            caching: true
        });
        var dics = new Dictionary<string,string>();
        for (const label of labels) {
            let OCTAVIAValorTraduccion = label.Title
            switch (lang) {
                case "EN":
                 OCTAVIAValorTraduccion = label?.OCTAVIANombreEn;
                  break;
                case "PT":
                  OCTAVIAValorTraduccion = label?.OCTAVIANombrePT;
                  break;
                case "FR":
                  OCTAVIAValorTraduccion = label?.OCTAVIANombreFR;
                  break;
            }
            dics.add(label["OCTAVIACodigo"], OCTAVIAValorTraduccion);
        }
        return dics;        
    }

	public async getAllFollowupData(): Promise<any> {
		let followIndex = await this.getOnlyFollowupData()
		let indicators = await this.getIndicatorsData()
		let beneficiaries = await this.getAllBeneficiariesData()
		let financial = await this.getFinancialData()

		return { ...indicators, ...beneficiaries, ...financial, followIndex }
	}

    public async getIndicatorsData(followupId?: string): Promise<any> {
        const result = await Promise.all([
            this.spListService.getPagedItems<any>({
                listName: Enums.ListTypes.SeguimientoIndObjEspecificos,
            }),
			this.spListService.getPagedItems<any>({
                listName: Enums.ListTypes.SeguimientoResultadosEsperados,
            }),
			this.spListService.getPagedItems<any>({
                listName: Enums.ListTypes.SeguimientoActividades,
            }),
			this.spListService.getPagedItems<any>({
                listName: Enums.ListTypes.SeguimientoLineaPrincipal,
            }),
			this.spListService.getPagedItems<any>({
                listName: Enums.ListTypes.SeguimientoLineaSecundaria,
            }),
			this.spListService.getPagedItems<any>({
                listName: Enums.ListTypes.SeguimientoResultadosInstitucionales,
            }),
			this.spListService.getPagedItems<any>({
                listName: Enums.ListTypes.SeguimientoProductosInstitucionales,
            })
        ]) as any;

        return {
            indObjEspecificos: result[0],
			indResEsperados: result[1],
			indActividades: result[2],
			indLineaPrincipal: result[3],
			indLineaSecundaria: result[4],
			indResInstitucionales: result[5],
			indProInstitucionales: result[6]
        };
    }

	public async getAllBeneficiariesData(): Promise<any> {
        const result = await Promise.all([
            this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByAge,
				columnsToSelect: Constants.Selects.AGE_RANGE,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByLocation,
				columnsToSelect: Constants.Selects.FOLLOWUP_LOCATION,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByRurality,
				columnsToSelect: Constants.Selects.FOLLOWUP_RURALITY,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByResult,
				columnsToSelect: Constants.Selects.FOLLOWUP_SUBPROJECT,
				expands: Constants.Expands.FOLLOWUP_SUBPROJECT,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByOverlap,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByGen,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesBySubPr,
            }),
        ]) as any;

        return {
            benByAge: result[0],
			benByLocation: result[1],
			benByRurality: result[2],
			benByResult: result[3],
			benByOverlap: result[4],
			benByGen: result[5],
			benBySubPr: result[6],
        };
    }

	public async getBeneficiariesData(followupId: string): Promise<any> {
        const result = await Promise.all([
            this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByAge,
				columnsToSelect: Constants.Selects.AGE_RANGE,
				filter: String.Format(Constants.FiltersFormats.FILTER_BY_SUBPROYECTOANIO, followupId)
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByLocation,
				columnsToSelect: Constants.Selects.FOLLOWUP_LOCATION,
				filter: String.Format(Constants.FiltersFormats.FILTER_BY_SUBPROYECTOANIO, followupId)
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByRurality,
				columnsToSelect: Constants.Selects.FOLLOWUP_RURALITY,
				filter: String.Format(Constants.FiltersFormats.FILTER_BY_SUBPROYECTOANIO, followupId)
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByResult,
				columnsToSelect: Constants.Selects.FOLLOWUP_SUBPROJECT,
				expands: Constants.Expands.FOLLOWUP_SUBPROJECT,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByOverlap,
				filter: String.Format(Constants.FiltersFormats.FILTER_BY_SUBPROYECTOANIO, followupId)
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesByGen,
				filter: String.Format(Constants.FiltersFormats.FILTER_BY_SUBPROYECTOANIO, followupId)
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.BeneficiariesBySubPr,
				filter: String.Format(Constants.FiltersFormats.FILTER_BY_SUBPROYECTOANIO, followupId)
            }),
        ]) as any;

        return {
            benByAge: result[0],
			benByLocation: result[1],
			benByRurality: result[2],
			benByResult: result[3],
			benByOverlap: result[4],
			benByGen: result[5],
			benBySubPr: result[6],
        };
    }

	public async getFinancialData(followupId?: string): Promise<any> {
        const result = await Promise.all([
            this.spListService.getItems<any>({
                listName: Enums.ListTypes.FinancieraPresupuestoImplementadores,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.FinancieraPresupuestoLocalizaciones,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.FinancieraPresupuestoADT,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.FinancieraPresupuestoSDC,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.FinancieraResultadosEsperados,
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.FinancieraResultadosEsperadosTotales,
            }),
        ]) as any;

        return {
            finImplementers: result[0],
			finLocations: result[1],
			finAdts: result[2],
			finSdcs: result[3],
			finResults: result[4],
			finTotalsResults: result[5]
        };
    }
    
    public async getResultsFramework(followupId: string, subvCode?: string): Promise<any> {
        let step4Response = await this.spListService.getItems<IFEStep4>({
            listName: Enums.ListTypes.ProaSubproyectoFEStep4,
            filter: String.Format(
                subvCode ? Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE : Constants.FiltersFormats.FILTER_BY_BUDGET_GRANT_CODE_NULL,
                followupId,
                subvCode
            ),
		});

		if (Utilities.isNullObject(step4Response) || step4Response.length === 0) {
			return null;
		}
      
			return Promise.all(
				step4Response.map(async (step4: IFEStep4) => {
				let step4Objetives: IFEStep4IndicadorObjetivo[] = await this.spListService.getItems<
					IFEStep4IndicadorObjetivo
				>({
					listName: Enums.ListTypes.ProaSubproyectoFEStep4Objetivo,
					filter: String.Format(
					Constants.FiltersFormats.FILTER_FE_STEP_4,
					step4.Id
					),
				});
		
				let objetives: IFEStep4IndicadoresDtoModel[] = await Promise.all(
					step4Objetives.map(
					async (step4Objetive: IFEStep4IndicadorObjetivo) => {
						let step2Info: IFEStep4IndicadoresDtoModel = {
						genericInfo: null,
						years: [],
						};
						step2Info.genericInfo = step4Objetive;
						step2Info.years = await this.spListService.getItems({
						listName: Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios,
						filter: String.Format(
							Constants.FiltersFormats.FILTER_FE_STEP_4_OBJETIVE,
							step4Objetive.Id
						),
						});
		
						return step2Info;
					}
					)
				);
		
				let step4Results = await this.spListService.getItems<
					IFEStep4ResultadoEsperado
				>({
					listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados,
					filter: String.Format(
					Constants.FiltersFormats.FILTER_FE_STEP_4,
					step4.Id
					),
					order: "Id",
					ascending: true,
				});
		
				let results: IFEStep4ResultsDtoModel[] = await Promise.all(
					step4Results.map(async (resultStep4: IFEStep4ResultadoEsperado) => {
					let result: IFEStep4ResultsDtoModel = {
						activities: [],
						genericInfo: null,
						details: [],
					};
					result.genericInfo = resultStep4;
		
					let expectedResults = await this.spListService.getItems<
						IFEStep4ResultadoEsperadoDetalle
					>({
						listName:
						Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetalles,
						filter: String.Format(
						Constants.FiltersFormats.FILTER_FE_STEP_4_RESULTS,
						result.genericInfo.Id
						),
					});
		
					let details: IFEStep4ResultsDetailsDtoModel[] = await Promise.all(
						expectedResults.map(
						async (expectedResult: IFEStep4ResultadoEsperadoDetalle) => {
							let detail: IFEStep4ResultsDetailsDtoModel = {
							genericInfo: null,
							years: [],
							};
							detail.genericInfo = expectedResult;
		
							detail.years = await this.spListService.getItems({
							listName:
								Enums.ListTypes
								.ProaSubproyectoFEStep4ResultadosDetallesAnios,
							filter: String.Format(
								Constants.FiltersFormats.FILTER_FE_STEP_4_RESULT_DETAIL,
								expectedResult.Id
							),
							});
		
							return detail;
						}
						)
					);
		
					result.details = details;
		
					let activitiesResponse = await this.spListService.getItems<
						IFEStep4Actividad
					>({
						listName: Enums.ListTypes.ProaSubproyectoFEStep4Actividad,
						filter: String.Format(
						Constants.FiltersFormats.FILTER_FE_STEP_4_RESULTS,
						result.genericInfo.Id
						),
					});
		
					let activities: IFEStep4ActivitiesDtoModel[] = await Promise.all(
						activitiesResponse.map(
						async (activityResponse: IFEStep4Actividad) => {
							let detail: IFEStep4ActivitiesDtoModel = {
							genericInfo: null,
							years: [],
							};
							detail.genericInfo = activityResponse;
		
							detail.years = await this.spListService.getItems({
							listName:
								Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios,
							filter: String.Format(
								Constants.FiltersFormats.FILTER_FE_STEP_4_ACTIVITY_DETAIL,
								activityResponse.Id
							),
							});
		
							return detail;
						}
						)
					);
		
					result.activities = activities;
		
					return result;
					})
				);
				
				return {
					genericInfo: step4,
					objetives: objetives,
					results: results,
				} as IFEStep4Dto;
				})
			) as any;
    }

	public async getSPFE(followupId: string, subvCode?: string): Promise<any> {
		let step1: IFEStep1Dto = await this.getFEStep1(followupId, subvCode);
        let step2: IFEStep2Dto = await this.getFEStep2(followupId, subvCode);
        let step3: IFEStep3Dto = await this.getFEStep3(followupId, subvCode);
        let stepSDC = await this.getStepSDC(followupId, subvCode);

        return {
			step1,
            step2,
            step3,
            stepSDC,
        }
    }

	protected async getFEStep1(followupId: string, subvCode?: string): Promise<IFEStep1Dto | null> {
		const genericInfo: any = {
			OCTAVIAFechaFinalizacion: null,
			OCTAVIAFechaInicio: null,
			PFFRRLineaBase: null,
			PProaAnioLineaBase: new Date(),
			PPresCodSubvencionId: subvCode,
			PPresPresupuestoId: followupId,
			PProaMetaFinal: 0,
			PPresTotalAnio: 0,
			PPresIndicadorLineaEstrategica1Id: 0,
			Id: 0,
		};
	
		let step1Response = await this.spListService.getItems<IFEStep1>({
			listName: Enums.ListTypes.ProaSubproyectoFRStep1,
			filter: String.Format(
				subvCode ? Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE : Constants.FiltersFormats.FILTER_BY_BUDGET_GRANT_CODE_NULL,
				followupId,
				subvCode
			),
		})
	
		if (step1Response.length === 0 ) {
		  	return Promise.resolve(null);
		}
	
		if (step1Response.length > 0) {
			genericInfo.PFFRRLineaBase = step1Response[0].PFFRRLineaBase;
			genericInfo.PProaAnioLineaBase = step1Response[0].PProaAnioLineaBase;
			genericInfo.PPresCodSubvencionId = step1Response[0].PPresCodSubvencionId;
			genericInfo.PPresPresupuestoId = step1Response[0].PPresPresupuestoId;
			genericInfo.PProaMetaFinal = step1Response[0].PProaMetaFinal;
			genericInfo.PPresTotalAnio = step1Response[0].PPresTotalAnio;
			genericInfo.PPresIndicadorLineaEstrategica1Id = step1Response[0].PPresIndicadorLineaEstrategica1Id;
			genericInfo.Id = step1Response[0].Id;
		}
		
		let [baseLineYears, beneficiaries] = await Promise.all([this.spListService.getItems<IFEStep1Anio>({
			listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios,
			filter: String.Format(
				Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP1,
				genericInfo.Id
			),
			order: "PPresAnioMeta",
		}), this.spListService.getItems<IFEStep1Beneficiario>({
			listName: Enums.ListTypes.BaseFFRRBeneficiarios,
			filter: String.Format(
				Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP1,
				genericInfo.Id
			),
		})]) as any;
	
		return {
			genericInfo,
			baseLineYears,
			beneficiaries,
		} as IFEStep1Dto;
	}

	protected async getFEStep2(followupId: string, subvCode?: string): Promise<IFEStep2Dto | null> {
		let step2Response = await this.spListService.getItems<IFEStep2>({
			listName: Enums.ListTypes.ProaSubproyectoFRStep2,
			filter: String.Format(
				subvCode ? Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE : Constants.FiltersFormats.FILTER_BY_BUDGET_GRANT_CODE_NULL,
                followupId,
                subvCode
			),
			columnsToSelect: Constants.Selects.PROA_SECTION_2,
			expands: Constants.Expands.PROA_SECTION_2,
		});

		if (Utilities.isNullObject(step2Response) || step2Response.length === 0) {
			return Promise.resolve(null);
		}

		let genericInfo = await Promise.all(
			step2Response.map(async (step2: IFEStep2) => {
				let step2Info: IFEStep2DtoModel = {
					basicInfo: null,
					implementerYears: [],
				};
				step2Info.basicInfo = step2;
				step2Info.implementerYears = await this.spListService.getItems({
					listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
					filter: String.Format(
						Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP2,
						step2.Id
					),
					order: "PPresAnioMeta",
				});

				return step2Info;
			})
		);

		return { genericInfo } as IFEStep2Dto;
	}

	protected async getFEStep3(followupId: string, subvCode?: string): Promise<IFEStep3Dto> {
		let response: IFEStep3Dto = {
			adts: [],
			zones: [],
		};

		let results = await this.spListService.getItems<any>({
			listName: Enums.ListTypes.ProaSubproyectoFRStep3,
			filter: String.Format(subvCode ? Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE : Constants.FiltersFormats.FILTER_BY_BUDGET_GRANT_CODE_NULL,
				followupId,
				subvCode),
			columnsToSelect: Constants.Selects.PROA_SECTION_3_IMPLEMENTERS,
			expands: Constants.Expands.PROA_SECTION_3_IMPLEMENTERS,
		  });
	  
		  let adts = results.filter(x => x.PProaAdtId)
		  let zones = results.filter(y => y.PProaLocationId)

		if (!Utilities.isNullObject(adts) && adts.length > 0) {
			response.adts = await Promise.all(
				adts.map(async (adt: IFEStep3) => {
					let step3: any = {};
					step3.genericInfo = adt;
					step3.details = await this.spListService.getItems({
						listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
						filter: String.Format(
							Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP3,
							adt.Id
						),
						order: "PPresAnioMeta",
					});

					return step3;
				})
			);
		}

		if (!Utilities.isNullObject(zones) && zones.length > 0) {
			response.zones = await Promise.all(
				zones.map(async (zone: IFEStep3) => {
					let step3: any = {};
					step3.genericInfo = zone;
					step3.details = await this.spListService.getItems({
						listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
						filter: String.Format(
							Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP3,
							zone.Id
						),
						order: "PPresAnioMeta",
					});

					return step3;
				})
			);
		}

		return response;
	}

	protected async getStepSDC(followupId: string, subvCode?: string): Promise<IDtoGetStepSDC | null> {
		
		let stepSDCResponse = await this.spListService.getItems<ISpfrStepSDC>({
			listName: Enums.ListTypes.ProaSubproyectoFRStepSDC,
			filter: String.Format(subvCode ? Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE : Constants.FiltersFormats.FILTER_BY_BUDGET_GRANT_CODE_NULL,
			followupId,
			subvCode)
		});
		if (Utilities.isNullObject(stepSDCResponse) || stepSDCResponse.length === 0) {
			return null;
		}
	
		let auxInfo = await Promise.all(
			stepSDCResponse.map(async (stepSDC: ISpfrStepSDC) => {
			let stepSDCInfo: any = {};
			stepSDCInfo.basicInfo = stepSDC;
			stepSDCInfo.counterpartsYears = await this.spListService.getItems({
				listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios,
				filter: String.Format(
				Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEPSDC,
				stepSDC.Id
				),
				order: "PPresAnioMeta",
			});
	
			return stepSDCInfo;
			})
		);
	
		let genericInfo = Utilities.copyObject(auxInfo) ;
		return { genericInfo };
	}

	public async getInstitutionalIndicators(followupId: string, subvCode?: string): Promise<any> {
		let MainLine: any = null
		let PProaMRI: any = []
		let step1Response = await this.spListService.getItems<ISpfrStep1>({
			listName: Enums.ListTypes.ProaSubproyectoFRStep1,
			filter: String.Format(subvCode ? Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE : Constants.FiltersFormats.FILTER_BY_BUDGET_GRANT_CODE_NULL,
				followupId,
				subvCode)
		});

		if (!Utilities.isNullObject(step1Response) && step1Response?.length) {
			let genericInfo = {
				...step1Response[0], 
				OCTAVIAFechaInicio: moment.utc(step1Response[0].OCTAVIAFechaInicio).tz(Constants.GeneralFormats.TIME_ZONE).format(Constants.GeneralFormats.DATE_FORMAT),
				OCTAVIAFechaFinalizacion: moment.utc(step1Response[0].OCTAVIAFechaFinalizacion).tz(Constants.GeneralFormats.TIME_ZONE).format(Constants.GeneralFormats.DATE_FORMAT)
			}    
	
			let baseLineYears = await this.spListService.getItems<ISpfrStep1Anio>({
				listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios,
				filter: String.Format(
					Constants.FiltersFormats.FILTER_PROA_SUBPROJECT_STEP1,
					genericInfo.Id
				),
				order: "PPresAnioMeta",
			});
	
			MainLine = {
				genericInfo,
				baseLineYears
			}
		}

		let step4MriResponse = await this.spListService.getItems<IFEStep4IndicadorMri>({
			listName: Enums.ListTypes.ProaSubproyectoFEStep4MRI,
			filter: String.Format(
			  Constants.FiltersFormats.FILTER_BY_BUDGET_AND_SUBVENTION_CODE,
			  followupId,
			  (!Utilities.isNullEmptyObject(subvCode)) ? subvCode : null
			),
		});

		if (!Utilities.isNullObject(step4MriResponse) && step4MriResponse.length) {
			PProaMRI =  await Promise.all(
				step4MriResponse.map(async (step4Mri: IFEStep4IndicadorMri) => {
					
					let step4Info: IFEStep4MriIndicadorDtoModel = {
					genericInfo: null,
					years: [],
					};
					step4Info.genericInfo = step4Mri;
					step4Info.years = await this.spListService.getItems({
						listName: Enums.ListTypes.ProaSubproyectoFEStep4MRIAnios,
						filter: String.Format(
							Constants.FiltersFormats.FILTER_FE_STEP_4_MRI,
							step4Mri.Id
						),
					});
			
					return step4Info;
				})
			);
		}
	
		return {
			MainLine,
			PProaMRI
		};
	}

	public async getNarrativeReport(followupId: string): Promise<any> {
		const result = await Promise.all([
            this.spListService.getItems({
				listName: Enums.ListTypes.SeguimientoEstadoSubproyectoPeriodos,
				filter: String.Format(
					Constants.FiltersFormats.FILTER_BY_SUBPROYECTOANIO,
					followupId
				),
			}),
            this.spListService.getItems({
				listName: Enums.ListTypes.SeguimientoInformeNarrativo,
				filter: String.Format(
					Constants.FiltersFormats.FILTER_BY_SUBPROYECTOANIO,
					followupId
				),
				columnsToSelect: Constants.Selects.INFORME_NARRATIVO,
            	expands: Constants.Expands.INFORME_NARRATIVO
			})
        ]) as any;
		
        return {
            periods: result[0],
            followupReport: result[1],
        };
	}

	public async getInfoByProject(PPresCodProy: string): Promise<any> {
		const result = await Promise.all([
            this.spListService.getItems({
				listName: Enums.ListTypes.BeneficiariesByGen,
				columnsToSelect: Constants.Selects.FOLLOWUP_SUBPROJECT,
				expands: Constants.Expands.FOLLOWUP_SUBPROJECT,
			}),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.IndexFollowup,
				filter: String.Format(
					Constants.FiltersFormats.FILTER_BY_PPRESCODPROY,
					PPresCodProy
				),
            }), 
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.FollowupByProjectOverlap,
				filter: String.Format(
					Constants.FiltersFormats.FILTER_BY_PPRESCODPROY,
					PPresCodProy
				),
            }),
			this.spListService.getItems<any>({
                listName: Enums.ListTypes.FollowupBenByProject,
				filter: String.Format(
					Constants.FiltersFormats.FILTER_BY_PPRESCODPROY,
					PPresCodProy
				),
            }),
        ]) as any;
		
        return {
            disaggregation: result[0],
			indexData: result[1],
			byProjectOverlap: result[2],
			benData: result[3]
		};
	}

	public async getInfoByCountry(idCountry: string, isCountry: boolean, year: string): Promise<any> {
		let codes: any[] = []
		let result2 = [], yearResults = []

		let result = await Promise.all([
			this.spListService.getItems<any>({
				listName: Enums.ListTypes.IndexFollowup,
				filter: String.Format(
					isCountry ? Constants.FiltersFormats.FILTER_FOLLOWUP_BY_COUNTRY : Constants.FiltersFormats.FILTER_FOLLOWUP_BY_REGION,
					idCountry,
					year
				),
			}),
			this.spListService.getItems<any>({
				listName: Enums.ListTypes.FollowupByCountryOverlap,
				filter: String.Format(
					isCountry ? Constants.FiltersFormats.FILTER_BY_COUNTRY : Constants.FiltersFormats.FILTER_BY_REGION,
					idCountry
				),
			}), 
			this.spListService.getItems<any>({
				listName: Enums.ListTypes.FollowupBenByCountry,
				filter: String.Format(
					isCountry ? Constants.FiltersFormats.FILTER_BY_COUNTRY : Constants.FiltersFormats.FILTER_BY_REGION,
					idCountry
				),
			}), 
			
		]) as any;

		if(result[0]?.length){
			result[0] = result[0].filter((res: any) => {
				if(!codes.includes(res.PPresCodProy)){
					codes.push(res.PPresCodProy)
					return res
				}
			})

			result2 = await Promise.all([
				...result[0].map((x: any) => 
				    this.spListService.getItems<any>({
						listName: Enums.ListTypes.FollowupBenByProject,
						filter: String.Format(
							Constants.FiltersFormats.FILTER_BY_PPRESCODPROY,
							x.PPresCodProy
						),
						columnsToSelect: Constants.Selects.FOLLOWUP_SUBPROJECTS,
						expands: Constants.Expands.FOLLOWUP_SUBPROJECTS,
					})
				)
				
			]) as any;

			for (const res of result2) {
				for (const item of res) {
					if(item?.SubProyectosAnio?.[0]?.Anio === year) yearResults.push(item)
				}
			}
		}

		return {
			indexData: result[0],
			byProjectData: yearResults || [],
			byCountryOverlap: result[1],
			benData: result[2]
		};
	}

	public async getMigrationData(): Promise<any> {
		const result = await Promise.all([
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFRStep1,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFRStep1Anios,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFEStep4MRI,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFEStep4MRIAnios,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFEStep4,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFEStep4Objetivo,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFEStep4ObjetivoAnios,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFEStep4Resultados,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetalles,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFEStep4ResultadosDetallesAnios,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFEStep4Actividad,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFEStep4ActividadAnios,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFRStep2,
				columnsToSelect: Constants.Selects.PROA_SECTION_2,
				expands: Constants.Expands.PROA_SECTION_2,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFRStep2Anios,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFRStep3,
				columnsToSelect: Constants.Selects.PROA_SECTION_3_IMPLEMENTERS,
				expands: Constants.Expands.PROA_SECTION_3_IMPLEMENTERS,	
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFRStep3Anios,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFRStepSDC,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.ProaSubproyectoFRStepSDCAnios,
			}),

			this.spListService.getPagedItems({
				listName: Enums.ListTypes.SeguimientoLineaPrincipal,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.SeguimientoLineaSecundaria,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.SeguimientoResultadosInstitucionales,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.SeguimientoProductosInstitucionales,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.SeguimientoIndObjEspecificos,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.SeguimientoResultadosEsperados,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.SeguimientoActividades,
			}),

			this.spListService.getPagedItems({
				listName: Enums.ListTypes.BeneficiariesByResult,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.FinancieraPresupuestoImplementadores,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.FinancieraResultadosEsperados,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.FinancieraPresupuestoLocalizaciones,
			}),
            this.spListService.getPagedItems({
				listName: Enums.ListTypes.FinancieraPresupuestoADT,
			}),
			this.spListService.getPagedItems({
				listName: Enums.ListTypes.FinancieraPresupuestoSDC,
			}),
			
        ]) as any;

		return {
			step1: result[0],
			step1Anios: result[1],
			stepMRI: result[2],
			stepMRIAnios: result[3],
			step4: result[4],
			step4Obj: result[5],
			step4ObjAnios: result[6],
			step4Res: result[7],
			step4ResDet: result[8],
			step4ResDetAnios: result[9],
			step4Act: result[10],
			step4ActAnios: result[11],
			step2: result[12],
			step2Anios: result[13],
			step3: result[14],
			step3Anios: result[15],
			stepSDC: result[16],
			stepSDCAnios: result[17],

			indLEPpal: result[18],
            indLESec: result[19],
            indLEResI: result[20],
            indLEProd: result[21],
            indObj: result[22],
            indResEsp: result[23],
            indAct: result[24],

			beneficiaries: result[25],
            budgetImp: result[26],
            budgetAct: result[27],
            budgetLoc: result[28],
            budgetADT: result[29],
            budgetSDC: result[30],
		}
	}

    private processGrantCodes(grantCodes: any): any {
		return grantCodes.map((x: any) => {
			x.Title = x.OCTAVIACodigoSubvencion;
			return x;
		});
    }

}
